import type { PolicyArtefactType, PolicySettings } from '@/lib/apiTypes'

export const ROLE_RANK: Record<string, number> = { reader: 1, member: 2, admin: 3, owner: 4 }

/** Plural artefact nouns for the kill-switch banner's sentence. */
export const ARTEFACT_NOUN: Record<string, string> = {
  module: 'modules', state: 'state', provider: 'providers', plan: 'plans',
}

export type Tab = 'overview' | 'decisions' | PolicyArtefactType

/** One artefact kind that policy applies to - NOT a tab identifier (features/providers has its
 *  own ArtefactTab for that). Each gets a tab on this page, hence the label.
 *  Per-scope metadata. `live` = enforcement actually gates: modules gate the
 *  registry download, state gates the next apply's LOCK, providers gate self-built
 *  file serving. `plan` is authorable now (org-baseline + identity-custom Rego) but its
 *  verdicts land once the plan scanner ships — the tab shows a not-yet-gating banner. */
export interface PolicyScope {
  key: PolicyArtefactType
  label: string
  blocked: (s: PolicySettings) => number
  live: boolean
}

export const POLICY_SCOPES: PolicyScope[] = [
  { key: 'module',   label: 'Modules',   blocked: (s) => s.modules_blocked_count,        live: true },
  { key: 'state',    label: 'State',     blocked: (s) => s.state_blocked_count ?? 0,      live: true },
  { key: 'provider', label: 'Providers', blocked: (s) => s.providers_blocked_count ?? 0,  live: true },
  { key: 'plan',     label: 'Plans',     blocked: () => 0,                                live: false },
]

export const TAB_KEYS: Tab[] = ['overview', 'decisions', ...POLICY_SCOPES.map((a) => a.key)]
